export const  VIRTUAL_ROOT_DEVICE_GROUP_ID = 'virtualRootId';
export const  VIRTUAL_ROOT_DEVICE_GROUP_NAME = ' ⌂ ';